import Spinner from '@/components/Spinner'
import useNative from '@/hooks/useNative'
import { showDialog } from 'vant'
import { useI18n } from '@/hooks/useI18n'
import { ServerError } from '@/model/serverError'
import router from '@/router'
import { unref } from 'vue'
import { useAppStore } from '@/store'

export default function handleHttpError(result) {
  const error = new ServerError(result)

  const { bCode } = error

  const { t } = useI18n()

  const { exit } = useNative()

  const skipCode = ['5107']

  const handleMethodsMap = new Map([
    [
      [
        '1008',
        '1039',
        '1042',
        '1043',
        '1044',
        '1046',
        '1047',
        '5001',
        '5003',
        '6010',
        '6024',
        '6025',
        '6029',
        '6030',
      ],
      (error) => alertAndJumpPage(error),
    ],
    [
      [
        '1001',
        '1017',
        '1026',
        '5001',
        '5011',
        '5013',
        '5017',
        '5022',
        '5024',
        '5027',
        '5038',
        '5042',
        '6009',
        '6011',
        '6013',
        '6021',
        '6022',
        '6027',
        '6041',
        '6103',
      ],
      (error) => alertAndJumpPage(error, 'payCardList'),
    ],
    [
      ['1006', '1007', '1013', '1015', '1016', '2007', '1029', '1031', '1034', '5010', '6003'],
      (error) => alertAndExitSDK(error),
    ],
    [
      ['2008', '2005', '6028'],
      (error) =>
        alertAndExitSDK(error, {
          exitCode: -2,
        }),
    ],

    [['1004', '1038'], () => exit()],
  ])

  // 特殊处理的code 不需要全局提示出来
  if (skipCode.includes(bCode)) {
    return
  }

  if (bCode === '9003') {
    showDialog({
      title: t('common.tipsText'),
      message: `登錄超時，請重試（${bCode}）`,
    }).then(() => useNative().exit())
  }

  showDialog({
    title: error.title || t('common.tipsText'),
    message: error.content,
    confirmButtonText: t('common.iSeeText'),
  }).then(() => {
    Spinner.close()
  })

  for (const codeArr of handleMethodsMap.keys()) {
    if (codeArr.includes(error.bCode)) {
      handleMethodsMap.get(codeArr)!(error)
    }
  }

  /**
   * 弹出提示框并退出SDK
   * @param error 错误内容
   * @param params 需要传递到设备的参数
   */
  function alertAndExitSDK(error, params?: any) {
    console.log('[HTTP: alertAndExitSDK]')
    Spinner.close()

    showDialog({
      title: error.title || t('common.tipsText'),
      message: error.content,
    }).then(() => {
      exit(params)
    })
  }

  /**
   * 弹出提示框并跳转到指定页面
   * @param error 错误内容
   * @param pageName 指定页面path
   */
  function alertAndJumpPage(error, pageName?: string) {
    console.log('[HTTP: alertAndJumpPage]')
    Spinner.close()

    showDialog({
      title: error.title || t('common.tipsText'),
      message: error.content,
    }).then(() => {
      if (pageName) {
        // 支付时有时跳转的太慢 加个loading
        Spinner.loading()

        const { token } = unref(router.currentRoute).query as any as QueryParams
        if (token && bCode === '5001') {
          // 解决安全设备认证时 验证码发送次数过多会跳到payCardList 又重定向回来 出现页面死循环
          useNative().exit()
          return
        }
        const backLength = window.history.length - useAppStore().historyStackLength
        router.go(-backLength)
        Spinner.close()
      }
    })
  }
}
